export default __webpack_public_path__ + "img/screenshot_3.96cefe28.png";